module.exports = __webpack_public_path__ + "img/nova.7b75c760.png";